import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { store } from '../store';
import isMedicoExterno from '../util/medicoHelpers';
import canAccessAdministracao from '../util/canAccessAdministracao';

export default function RouteWrapper({
  component: Component,
  isPrivate = false,
  allowExternalDoctor = false,
  requireAdminFuncionario: requireAdmin = false,
  perfis,
  ...rest
}) {
  const { signed } = store.getState().patient; // TODO: melhorar nomenclatura
  const { profile } = store.getState().doctor; // TODO: melhorar nomenclatura
  const { logado, funcionario } = store.getState().funcionario; // TODO: melhorar nomenclatura

  if (!profile && !signed && !logado && isPrivate) return <Redirect to="/" />;
  if (signed && !isPrivate) return <Redirect to="/paciente/inicio" />;

  const isExternalDoctor = isMedicoExterno(profile);
  if (isPrivate && isExternalDoctor && !allowExternalDoctor) {
    return <Redirect to="/not-allowed" />;
  }

  let perfilAtual = null;
  if (profile) perfilAtual = 'medico';
  else if (logado) perfilAtual = 'funcionario';
  else if (signed) perfilAtual = 'paciente';

  if (isPrivate && perfis?.length && !perfis.includes(perfilAtual)) {
    return <Redirect to="/not-allowed" />;
  }

  if (isPrivate && requireAdmin) {
    if (!canAccessAdministracao(profile, funcionario)) {
      return <Redirect to="/not-allowed" />;
    }
  }

  return <Route {...rest} render={props => <Component {...props} />} />;
}
